import React from "react";
// import { BiSolidCheckCircle } from "react-icons/bi";
// import { IoMdCheckmarkCircleOutline } from "react-icons/io";
// import { FaRegFileExcel } from "react-icons/fa6";
import { GiCarDoor } from "react-icons/gi";
import {
  LuCalendarCheck2,
  LuRectangleHorizontal,
  LuCar,
  LuCarFront,
} from "react-icons/lu";
import { LiaCarSideSolid } from "react-icons/lia";
import carConditionImage from "./assets/car-condition-image.png";
// import mileageImage from "./assets/car-spare/mileage.svg";
import fuelImage from "./assets/car-spare/fuel-line.svg";
// import fuelGuage from "./assets/car-spare/fuel-level.svg";
// import OilGauge from "./assets/car-spare/oil-level.svg";
import batteryBox from "./assets/car-spare/battery.svg";
import tyresImage from "./assets/car-spare/spare.svg";
// import wheelImage from "./assets/car-spare/wheel.svg";
import mirrorImage from "./assets/car-spare/sidemirror.svg";
import rubberImage from "./assets/car-spare/rubber-carpet.svg";
import wiperImage from "./assets/car-spare/wiper.svg";
import seatImage from "./assets/car-spare/car-seat-cover.svg";
import carAudio from "./assets/car-spare/car-audio.svg";
// import audioImage from "./assets/car-spare/car-audio.svg";
import toolBox from "./assets/car-spare/tools-box.svg";
import jackImage from "./assets/car-spare/car-jack.svg";
// import { Link } from "react-router-dom";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useRef, useEffect, useState } from "react";
import useCustomMethods from "../hooks/useCustomMethods";
import IconButton from "@mui/material/IconButton";
import { CgClose } from "react-icons/cg";
import { getFiles } from "../services/bookingApi";
import Loading from "./LoadingComponent";
// import { styled } from "@mui/material/styles";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  ImageList,
  ImageListItem,
  ImageListItemBar,
} from "@mui/material";

const CarCondition = ({ close, condition, title, loading, setLoading }) => {
  const col1Ref = useRef(null);
  const col2Ref = useRef(null);
  const col3Ref = useRef(null);
  const col4Ref = useRef(null);
  const col5Ref = useRef(null);
  const col6Ref = useRef(null);
  const col7Ref = useRef(null);
  const col8Ref = useRef(null);
  const [open, setOpen] = useState(false);

  const setBorderToLongest = () => {
    const col1 = col1Ref.current;
    const col2 = col2Ref.current;
    col1.classList.remove("border-right");
    col2.classList.remove("border-left");
    if (col1.offsetHeight > col2.offsetHeight)
      col1.classList.add("border-right");
    else col2.classList.add("border-left");

    const col3 = col3Ref.current;
    const col4 = col4Ref.current;
    col3.classList.remove("border-right");
    col4.classList.remove("border-left");
    if (col3.offsetHeight > col4.offsetHeight)
      col3.classList.add("border-right");
    else col4.classList.add("border-left");

    const col5 = col5Ref.current;
    const col6 = col6Ref.current;
    col5.classList.remove("border-right");
    col6.classList.remove("border-left");
    if (col5.offsetHeight > col6.offsetHeight)
      col5.classList.add("border-right");
    else col6.classList.add("border-left");

    const col7 = col7Ref.current;
    const col8 = col8Ref.current;
    col7.classList.remove("border-right");
    col8.classList.remove("border-left");
    if (col7.offsetHeight > col8.offsetHeight)
      col7.classList.add("border-right");
    else col8.classList.add("border-left");
  };
  const [fileData, setFileData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  // const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  //   "& .MuiDialogContent-root": {
  //     padding: theme.spacing(2),
  //   },
  //   "& .MuiDialogActions-root": {
  //     padding: theme.spacing(1),
  //   },
  // }));
  const closeFunc = () => {
    close(false);
    // setLoading(true);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
    setIsLoading(true);
  };

  const { getColor, firstLetterUpperCase, replaceUrl, isVideoUrl } =
    useCustomMethods();

  const getFilesApi = () => {
    const formData = new FormData();
    formData.append("assignid", condition?.assign_reference);
    formData.append("bookingid", condition?.bookingid);
    getFiles(formData).then((res) => {
      if (res.data.files) {
        setFileData(res.data.files);
        setIsLoading(false);
      }
    });
  };

  useEffect(() => {
    // if (!loading) setBorderToLongest();
    setBorderToLongest();
  }, []);
  useEffect(() => {
    if (open) getFilesApi();
  }, [open]);
  return (
    <div className="model conditionModel">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header p-0 border-none">
            <div className="modal-title">
              <span className="modal-title f-20">
                Car Condition Report For {title}
              </span>
            </div>
            <div className="btn-close" onClick={() => closeFunc(false)}>
              <AiOutlineCloseCircle />
            </div>
          </div>

          {loading ? (
            <div className="modal-body car-condition-body">
              <div className=" h-100 d-flex justify-content-center align-items-center">
                <Loading />
              </div>
            </div>
          ) : (
            <div className="modal-body car-condition-body">
              <div className="row form-row m-0 mt-4 pink">
                <div className="col col-md-6 col-12">
                  <p className="sub-heading ">
                    {condition?.car_make + "- " + condition?.car_model + " "}
                    <span className="text-para black">
                      {condition?.car_color + ", " + condition?.car_type}
                    </span>
                  </p>
                  <span className="sub-heading">
                    <p className="text-para d-inline">Chassis No : </p>
                    {condition?.chasis_no}
                  </span>
                  <span className="sub-heading">
                    <p className="text-para d-inline">Engine No : </p>
                    {condition?.engine_no}
                  </span>
                  <span className="sub-heading">
                    <p className="text-para d-inline">Mileage on pickup : </p>
                    {condition?.interior?.odometer}
                  </span>
                </div>
                <div className="col col-md-6 col-12 carImage">
                  <img
                    src={carConditionImage}
                    width={233}
                    height={86}
                    loading="eager"
                    alt="condition of the car"
                  />
                </div>
              </div>
              {/* <div className="row mt-2rem m-0 gray"> */}
              {/* <div className="col col-md-4 col-12"> */}
              {/* <div className="flex-around">
                  <p className="condition-para me-3 mb-0">
                    <img
                      src={mileageImage}
                      width={20}
                      height={20}
                      loading="eager"
                      alt="Mileage on pickup"
                    />{" "}
                    <span>Mileage on pickup</span>
                  </p>
                  <p className="condition-para fw-700 mb-0 d-flex align-items-center">
                    {condition?.interior.odometer}
                  </p>
                </div> */}
              {/* </div> */}
              {/* <div className="col col-md-4 col-12 border-l-r">
                  <div className="flex-around">
                    <p className="condition-para"> Mileage on Hub</p>
                    <p className="condition-para fw-700"> 102356 </p>
                  </div>
                </div>
                <div className="col col-md-4 col-12">
                  <div className="flex-around">
                    <p className="condition-para"> Delivery Mileage</p>
                    <p className="condition-para fw-700"> 102356</p>
                  </div>
                </div> */}
              {/* </div> */}
              <div className="row form-row m-0 mt-4">
                <div
                  className="col col-md-6 col-12 border-right mb-3 pt-2 pb-3"
                  ref={col1Ref}
                >
                  <p className="mainSub-heading"> Basic Vehicle Information</p>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <img
                        src={fuelImage}
                        width={20}
                        height={20}
                        loading="eager"
                        alt="FuelImage"
                      />
                      Fuel
                    </div>
                    <div className="condition-para fw-semibold">
                      {firstLetterUpperCase(condition?.fuel_type)}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <LuCalendarCheck2 color="#00000087" />
                      Year of Manufacture
                    </div>
                    <div className="condition-para fw-semibold">
                      {firstLetterUpperCase(condition?.year_of_manufacture)}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <LuRectangleHorizontal color="#00000087" />
                      License Plate Number
                    </div>
                    <div className="condition-para fw-semibold">
                      {firstLetterUpperCase(condition?.license_plate_number)}
                    </div>
                  </div>
                  {condition?.general_comment && (
                    <div className="carDetails">
                      <div className="condition-para me-2">
                        <LuCar
                          color="#00000087"
                          style={{ width: 22, height: 22 }}
                        />
                        Comment
                      </div>
                      <div className="condition-para fw-semibold">
                        {firstLetterUpperCase(condition?.general_comment)}
                      </div>
                    </div>
                  )}
                </div>
                <div
                  className="col col-md-6 col-12 padding-left border-left mb-3"
                  ref={col2Ref}
                >
                  <p className="mainSub-heading mb-2">Exterior Inspection</p>
                  <p className="sub-heading">Body Panels</p>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <LuCar
                        color="#00000087"
                        style={{ width: 22, height: 22 }}
                      />
                      Condition
                    </div>

                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["All Good"],
                        ["Severe Scratches", "Scratches & Dents"],
                        condition?.body_panels
                      )}`}
                    >
                      {firstLetterUpperCase(condition?.body_panels)}
                    </div>
                  </div>
                  {condition?.exterior_comment && (
                    <div className="carDetails">
                      <div className="condition-para me-2">
                        <LuCar
                          color="#00000087"
                          style={{ width: 22, height: 22 }}
                        />
                        Comment
                      </div>
                      <div className="condition-para fw-semibold">
                        {firstLetterUpperCase(condition?.exterior_comment)}
                      </div>
                    </div>
                  )}

                  <p className="sub-heading mt-3">Battery</p>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <img
                        src={batteryBox}
                        width={22}
                        height={22}
                        loading="eager"
                        alt="Mileage on pickup"
                      />{" "}
                      Brand
                    </div>
                    <div className="condition-para fw-semibold">
                      {firstLetterUpperCase(condition?.battery_make)}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <img
                        src={batteryBox}
                        width={22}
                        height={22}
                        loading="eager"
                        alt="Mileage on pickup"
                      />{" "}
                      Serial Number
                    </div>
                    <div className="condition-para fw-semibold">
                      {firstLetterUpperCase(condition?.battery_serial_no)}
                    </div>
                  </div>
                  {condition?.battery_comments && (
                    <div className="carDetails">
                      <div className="condition-para me-2">
                        <img
                          src={batteryBox}
                          width={22}
                          height={22}
                          loading="eager"
                          alt="FuelImage"
                        />
                        Comment
                      </div>
                      <div className="condition-para fw-semibold">
                        {firstLetterUpperCase(condition?.battery_comments)}
                      </div>
                    </div>
                  )}
                </div>
                {/* </div> */}

                <div
                  className="col col-md-6 col-12 border-right mb-3 pt-2 pb-3"
                  ref={col3Ref}
                >
                  <p className="sub-heading">Glass</p>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <LuCarFront
                        style={{ width: 22, height: 22 }}
                        color="#00000087"
                      />
                      Windshield
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Good"],
                        ["Broken", "Not Good"],
                        condition?.glassinfo?.windshield
                      )}`}
                    >
                      {firstLetterUpperCase(condition?.glassinfo?.windshield)}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <LiaCarSideSolid
                        style={{ width: 22, height: 22 }}
                        color="#00000087"
                      />
                      Driver side Window Glass
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Good"],
                        ["Broken", "Not Good"],
                        condition?.glassinfo?.driver_window_glass
                      )}`}
                    >
                      {firstLetterUpperCase(
                        condition?.glassinfo?.driver_window_glass
                      )}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <LiaCarSideSolid
                        style={{ width: 22, height: 22 }}
                        color="#00000087"
                      />
                      Front Left Side Window Glass
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Good"],
                        ["Broken", "Not Good"],
                        condition?.glassinfo?.left_window_glass
                      )}`}
                    >
                      {firstLetterUpperCase(
                        condition?.glassinfo?.left_window_glass
                      )}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <LiaCarSideSolid
                        style={{ width: 22, height: 22 }}
                        color="#00000087"
                      />
                      Rear Right Side Window Glass
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Good"],
                        ["Broken", "Not Good"],
                        condition?.glassinfo?.back_side_right_window_glass
                      )}`}
                    >
                      {firstLetterUpperCase(
                        condition?.glassinfo?.back_side_right_window_glass
                      )}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <LiaCarSideSolid
                        style={{ width: 22, height: 22 }}
                        color="#00000087"
                      />
                      Rear Left Side Window Glass
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Good"],
                        ["Broken", "Not Good"],
                        condition?.glassinfo?.back_side_left_window_glass
                      )}`}
                    >
                      {firstLetterUpperCase(
                        condition?.glassinfo?.back_side_left_window_glass
                      )}
                    </div>
                  </div>
                  {condition?.glassinfo?.glass_comments && (
                    <div className="carDetails">
                      <div className="condition-para me-2">
                        <LiaCarSideSolid
                          style={{ width: 22, height: 22 }}
                          color="#00000087"
                        />
                        Comment
                      </div>
                      <div className="condition-para fw-semibold">
                        {firstLetterUpperCase(
                          condition?.glassinfo?.glass_comments
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div
                  className="col col-md-6 mb-3 col-12 padding-left mb-2"
                  ref={col4Ref}
                >
                  <p className="sub-heading">Tires / Wheel Caps</p>
                  <div className="carDetails">
                    <div className="condition-para">
                      <img
                        src={tyresImage}
                        width={22}
                        height={22}
                        loading="eager"
                        alt="FuelImage"
                      />
                      Front Right
                    </div>
                    <div className="condition-para fw-semibold">
                      {condition?.tyres_front_right_brand
                        ? condition?.tyres_front_right_brand
                        : " - "}
                      {" / "}
                      {condition?.wheel_caps.wheel_caps_front_right ? (
                        <span
                          className={`${getColor(
                            ["good"],
                            ["bad"],
                            condition?.tyres_front_right_condition
                          )} fw-bold`}
                        >
                          {firstLetterUpperCase(
                            condition?.tyres_front_right_condition
                          )}
                        </span>
                      ) : (
                        "-"
                      )}{" "}
                      /{" "}
                      {condition?.wheel_caps.wheel_caps_front_right ? (
                        <span
                          className={`${getColor(
                            ["good"],
                            ["bad"],
                            condition?.wheel_caps.wheel_caps_front_right
                          )} fw-bold`}
                        >
                          {firstLetterUpperCase(
                            condition?.wheel_caps.wheel_caps_front_right
                          )}
                        </span>
                      ) : (
                        "-"
                      )}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para">
                      <img
                        src={tyresImage}
                        width={22}
                        height={22}
                        loading="eager"
                        alt="FuelImage"
                      />
                      Front Left
                    </div>
                    <div className="condition-para fw-semibold">
                      {condition?.tyres_front_left_brand
                        ? condition?.tyres_front_left_brand
                        : " - "}{" "}
                      /{" "}
                      {condition?.tyres_front_left_condition ? (
                        <span
                          className={`${getColor(
                            ["good"],
                            ["bad"],
                            condition?.tyres_front_left_condition
                          )} fw-bold`}
                        >
                          {firstLetterUpperCase(
                            condition?.tyres_front_left_condition
                          )}
                        </span>
                      ) : (
                        "-"
                      )}{" "}
                      /{" "}
                      {condition?.wheel_caps.wheel_caps_front_left ? (
                        <span
                          className={`${getColor(
                            ["good"],
                            ["bad"],
                            condition?.wheel_caps.wheel_caps_front_left
                          )} fw-bold`}
                        >
                          {firstLetterUpperCase(
                            condition?.wheel_caps.wheel_caps_front_left
                          )}
                        </span>
                      ) : (
                        "-"
                      )}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para">
                      <img
                        src={tyresImage}
                        width={22}
                        height={22}
                        loading="eager"
                        alt="FuelImage"
                      />
                      Rear Right
                    </div>
                    <div className="condition-para fw-semibold">
                      {condition?.tyres_rear_right_brand
                        ? condition?.tyres_rear_right_brand
                        : "-"}{" "}
                      /{" "}
                      {condition?.tyres_rear_right_condition ? (
                        <span
                          className={`${getColor(
                            ["good"],
                            ["bad"],
                            condition?.tyres_rear_right_condition
                          )} fw-bold`}
                        >
                          {firstLetterUpperCase(
                            condition?.tyres_rear_right_condition
                          )}
                        </span>
                      ) : (
                        "-"
                      )}{" "}
                      /{" "}
                      {condition?.wheel_caps.wheel_caps_front_left ? (
                        <span
                          className={`${getColor(
                            ["good"],
                            ["bad"],
                            condition?.wheel_caps.wheel_caps_rear_right
                          )} fw-bold`}
                        >
                          {firstLetterUpperCase(
                            condition?.wheel_caps.wheel_caps_rear_right
                          )}
                        </span>
                      ) : (
                        "-"
                      )}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para">
                      <img
                        src={tyresImage}
                        width={22}
                        height={22}
                        loading="eager"
                        alt="FuelImage"
                      />
                      Rear Left
                    </div>
                    <div className="condition-para fw-semibold">
                      {condition?.tyres_rear_left_brand
                        ? condition?.tyres_rear_left_brand
                        : "-"}{" "}
                      /{" "}
                      {condition?.tyres_rear_left_condition ? (
                        <span
                          className={`${getColor(
                            ["good"],
                            ["bad"],
                            condition?.tyres_rear_left_condition
                          )} fw-bold`}
                        >
                          {firstLetterUpperCase(
                            condition?.tyres_rear_left_condition
                          )}
                        </span>
                      ) : (
                        "-"
                      )}{" "}
                      /{" "}
                      {condition?.wheel_caps.wheel_caps_rear_left ? (
                        <span
                          className={`${getColor(
                            ["good"],
                            ["bad"],
                            condition?.wheel_caps.wheel_caps_rear_left
                          )} fw-bold`}
                        >
                          {firstLetterUpperCase(
                            condition?.wheel_caps.wheel_caps_rear_left
                          )}
                        </span>
                      ) : (
                        "-"
                      )}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para">
                      <img
                        src={tyresImage}
                        width={22}
                        height={22}
                        loading="eager"
                        alt="FuelImage"
                      />
                      Stepney 
                    </div>
                    <div className="condition-para fw-semibold">
                      {condition?.tyres_stepney_brand
                        ? condition?.tyres_stepney_brand
                        : "-"}{" "}
                      /{" "}
                      {condition?.tyres_stepney_condition ? (
                        <span
                          className={`${getColor(
                            ["good"],
                            ["bad"],
                            condition?.tyres_stepney_condition
                          )} fw-bold`}
                        >
                          {firstLetterUpperCase(
                            condition?.tyres_stepney_condition
                          )}
                        </span>
                      ) : (
                        "-"
                      )}{" "}
                      /{" "}
                      {condition?.wheel_caps_stepney ? (
                        <span
                          className={`${getColor(
                            ["good"],
                            ["bad"],
                            condition?.wheel_caps_stepney
                          )} fw-bold`}
                        >
                          {firstLetterUpperCase(condition?.wheel_caps_stepney)}
                        </span>
                      ) : (
                        "-"
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className="col col-md-6 col-12 border-right mb-3 pt-2 pb-3"
                  ref={col5Ref}
                >
                  <p className="sub-heading">Light Glass</p>
                  <div className="carDetails me-2">
                    <div className="condition-para me-2">
                      <LuCar
                        style={{ width: 22, height: 22 }}
                        color="#00000087"
                      />
                      Headlight
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Available"],
                        ["One side broken", "Both side broken"],
                        condition?.glassinfo?.headlight
                      )}`}
                    >
                      {firstLetterUpperCase(condition?.glassinfo?.headlight)}
                    </div>
                  </div>
                  <div className="carDetails me-2">
                    <div className="condition-para me-2">
                      <LuCar
                        style={{ width: 22, height: 22 }}
                        color="#00000087"
                      />
                      Taillights
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Available"],
                        ["One side broken", "Both side broken"],
                        condition?.glassinfo?.taillights
                      )}`}
                    >
                      {firstLetterUpperCase(condition?.glassinfo?.taillights)}
                    </div>
                  </div>
                  <div className="carDetails me-2">
                    <div className="condition-para me-2">
                      <LuCar
                        style={{ width: 22, height: 22 }}
                        color="#00000087"
                      />
                      Fog lights
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Available"],
                        ["One side broken", "Both side broken"],
                        condition?.glassinfo?.fog_lights
                      )}`}
                    >
                      {firstLetterUpperCase(condition?.glassinfo?.fog_lights)}
                    </div>
                  </div>
                  {condition?.glassinfo?.lights_comments && (
                    <div className="carDetails">
                      <div className="condition-para me-2">
                        <LuCar
                          style={{ width: 22, height: 22 }}
                          color="#00000087"
                        />
                        Comment
                      </div>
                      <div className="condition-para fw-semibold">
                        {firstLetterUpperCase(
                          condition?.glassinfo?.lights_comments
                        )}
                      </div>
                    </div>
                  )}
                  <p className="sub-heading mt-3">Side Mirrors</p>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <img
                        src={mirrorImage}
                        width={20}
                        height={20}
                        loading="eager"
                        alt="FuelImage"
                      />
                      Right
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Available & Good Condition"],
                        ["Not Available", "Available Not Good"],
                        condition?.side_mirrors_right
                      )}`}
                    >
                      {firstLetterUpperCase(condition?.side_mirrors_right)}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <img
                        src={mirrorImage}
                        width={20}
                        height={20}
                        loading="eager"
                        alt="FuelImage"
                      />
                      Left
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Available & Good Condition"],
                        ["Not Available", "Available Not Good"],
                        condition?.side_mirrors_left
                      )}`}
                    >
                      {firstLetterUpperCase(condition?.side_mirrors_left)}
                    </div>
                  </div>
                  {condition?.sidemirror_comments && (
                    <div className="carDetails">
                      <div className="condition-para me-2">
                        <img
                          src={mirrorImage}
                          width={20}
                          height={20}
                          loading="eager"
                          alt="FuelImage"
                        />
                        Comment
                      </div>
                      <div className="condition-para fw-semibold">
                        {firstLetterUpperCase(condition?.sidemirror_comments)}
                      </div>
                    </div>
                  )}
                </div>
                <div
                  className="col col-md-6 col-12 padding-left border-left mb-3"
                  ref={col6Ref}
                >
                  <p className="mainSub-heading mb-2">Interior Inspection</p>
                  <p className="sub-heading">Seating</p>
                  <div className="carDetails me-2">
                    <div className="condition-para me-2">
                      <img
                        src={seatImage}
                        width={20}
                        height={20}
                        loading="eager"
                        alt="FuelImage"
                      />
                      Condition
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Good"],
                        ["Bad"],
                        condition?.interior?.seatcondition
                      )}`}
                    >
                      {firstLetterUpperCase(condition?.interior?.seatcondition)}
                    </div>
                  </div>
                  <div className="carDetails me-2">
                    <div className="condition-para me-2">
                      <img
                        src={seatImage}
                        width={20}
                        height={20}
                        loading="eager"
                        alt="FuelImage"
                      />
                      Cover
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Available"],
                        ["Not Available", "Available But Not Good"],
                        condition?.interior?.seatcover
                      )}`}
                    >
                      {firstLetterUpperCase(condition?.interior?.seatcover)}
                    </div>
                  </div>

                  {condition?.interior?.seat_comment && (
                    <div className="carDetails">
                      <div className="condition-para me-2">
                        <img
                          src={seatImage}
                          width={20}
                          height={20}
                          loading="eager"
                          alt="FuelImage"
                        />
                        Comment
                      </div>
                      <div className="condition-para fw-semibold">
                        {firstLetterUpperCase(
                          condition?.interior?.seat_comment
                        )}
                      </div>
                    </div>
                  )}
                  <p className="sub-heading mt-3">Dashboard & Console</p>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <img
                        src={carAudio}
                        width={22}
                        height={22}
                        loading="eager"
                        alt="FuelImage"
                      />
                      Condition
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Available"],
                        ["Not Available", "Available But Not Good"],
                        condition?.interior?.dashboard_console
                      )}`}
                    >
                      {firstLetterUpperCase(
                        condition?.interior?.dashboard_console
                      )}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <img
                        src={carAudio}
                        width={22}
                        height={22}
                        loading="eager"
                        alt="FuelImage"
                      />
                      Dash Camera
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Available"],
                        ["Not Available"],
                        condition?.interior?.dash_camera
                      )}`}
                    >
                      {firstLetterUpperCase(condition?.interior?.dash_camera)}
                    </div>
                  </div>
                  {condition?.interior?.dashboard_comment && (
                    <div className="carDetails">
                      <div className="condition-para me-2">
                        <img
                          src={carAudio}
                          width={22}
                          height={22}
                          loading="eager"
                          alt="FuelImage"
                        />
                        Comment
                      </div>
                      <div className="condition-para fw-semibold">
                        {firstLetterUpperCase(
                          condition?.interior?.dashboard_comment
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div
                  className="col col-md-6 col-12 border-right mb-3 pt-2 pb-3"
                  ref={col7Ref}
                >
                  <p className="sub-heading">Flooring</p>
                  <div className="carDetails me-2">
                    <div className="condition-para me-2">
                      <img
                        src={rubberImage}
                        width={22}
                        height={22}
                        loading="eager"
                        alt="FuelImage"
                      />
                      Floor Mat
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Available"],
                        ["Not Available", "Available But Not Good"],
                        condition?.interior?.floor_mat
                      )}`}
                    >
                      {firstLetterUpperCase(condition?.interior?.floor_mat)}
                    </div>
                  </div>

                  {condition?.interior?.floor_comment && (
                    <div className="carDetails">
                      <div className="condition-para me-2">
                        <img
                          src={rubberImage}
                          width={22}
                          height={22}
                          loading="eager"
                          alt="FuelImage"
                        />
                        Comment
                      </div>
                      <div className="condition-para fw-semibold">
                        {firstLetterUpperCase(
                          condition?.interior?.floor_comment
                        )}
                      </div>
                    </div>
                  )}
                  <p className="sub-heading mt-3">Door Panels</p>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <GiCarDoor
                        style={{ width: 22, height: 22 }}
                        color="#00000087"
                      />
                      Condition
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["All Good"],
                        ["Damaged Parts"],
                        condition?.interior?.door_panels
                      )}`}
                    >
                      {firstLetterUpperCase(condition?.interior?.door_panels)}
                    </div>
                  </div>

                  {condition?.interior?.door_panels_comment && (
                    <div className="carDetails">
                      <div className="condition-para me-2">
                        <GiCarDoor
                          style={{ width: 22, height: 22 }}
                          color="#00000087"
                        />
                        Comment
                      </div>
                      <div className="condition-para fw-semibold">
                        {firstLetterUpperCase(
                          condition?.interior?.door_panels_comment
                        )}
                      </div>
                    </div>
                  )}
                  <p className="sub-heading mt-3">Tools</p>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <img
                        src={toolBox}
                        width={22}
                        height={22}
                        loading="eager"
                        alt="FuelImage"
                      />
                      Tool Kit
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Available"],
                        ["Not Available"],
                        condition?.interior?.toolkit
                      )}`}
                    >
                      {firstLetterUpperCase(condition?.interior?.toolkit)}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <img
                        src={jackImage}
                        width={22}
                        height={22}
                        loading="eager"
                        alt="FuelImage"
                      />
                      Jack
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Available"],
                        ["Not Available"],
                        condition?.interior?.jack
                      )}`}
                    >
                      {firstLetterUpperCase(condition?.interior?.jack)}
                    </div>
                  </div>
                  {condition?.interior?.toolkit_comment && (
                    <div className="carDetails">
                      <div className="condition-para me-2">
                        <LuRectangleHorizontal
                          style={{ width: 22, height: 22 }}
                          color="#00000087"
                        />
                        Comment
                      </div>
                      <div className="condition-para fw-semibold">
                        {firstLetterUpperCase(
                          condition?.interior?.toolkit_comment
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div
                  className="col col-md-6 col-12 padding-left border-left mb-3"
                  ref={col8Ref}
                >
                  <p className="mainSub-heading mb-2">
                    Car Functionality Check
                  </p>
                  <div className="carDetails me-2">
                    <div className="condition-para me-2">
                      <GiCarDoor
                        style={{ width: 22, height: 22 }}
                        color="#00000087"
                      />
                      Power windows
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["All Working"],
                        ["Few Not Working", "Not Working Completely"],
                        condition?.checkfunctionality?.power_windows
                      )}`}
                    >
                      {firstLetterUpperCase(
                        condition?.checkfunctionality?.power_windows
                      )}
                    </div>
                  </div>
                  <div className="carDetails me-2">
                    <div className="condition-para me-2">
                      <GiCarDoor
                        style={{ width: 22, height: 22 }}
                        color="#00000087"
                      />
                      Door Locks
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["All Working"],
                        ["Few Not Working", "Not Working Completely"],
                        condition?.checkfunctionality?.door_locks
                      )}`}
                    >
                      {firstLetterUpperCase(
                        condition?.checkfunctionality?.door_locks
                      )}
                    </div>
                  </div>

                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <img
                        src={wiperImage}
                        width={22}
                        height={22}
                        loading="eager"
                        alt="FuelImage"
                      />
                      Wiper Arms & Blades
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["All Working"],
                        ["Not Working Completely"],
                        condition?.checkfunctionality?.wiper_arms_blades
                      )}`}
                    >
                      {firstLetterUpperCase(
                        condition?.checkfunctionality?.wiper_arms_blades
                      )}
                    </div>
                  </div>

                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <LuCar
                        style={{ width: 22, height: 22 }}
                        color="#00000087"
                      />
                      Headlight
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["All Working"],
                        ["One Side Not Working", "Not Working", "NA"],
                        condition?.checkfunctionality?.headlight
                      )}`}
                    >
                      {firstLetterUpperCase(
                        condition?.checkfunctionality?.headlight
                      )}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <LuCar
                        style={{ width: 22, height: 22 }}
                        color="#00000087"
                      />
                      Tail lights
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["All Working"],
                        ["One Side Not Working", "Not Working", "NA"],
                        condition?.checkfunctionality?.tail_lights
                      )}`}
                    >
                      {firstLetterUpperCase(
                        condition?.checkfunctionality?.tail_lights
                      )}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <LuCar
                        style={{ width: 22, height: 22 }}
                        color="#00000087"
                      />
                      Fog lights
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["All Working"],
                        ["One Side Not Working", "Not Working", "NA"],
                        condition?.checkfunctionality?.fog_lights
                      )}`}
                    >
                      {firstLetterUpperCase(
                        condition?.checkfunctionality?.fog_lights
                      )}
                    </div>
                  </div>
                </div>
                <div className="col col-md-6 col-12 border-right mb-3 pt-2 pb-3">
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <img
                        src={carAudio}
                        width={22}
                        height={22}
                        loading="eager"
                        alt="FuelImage"
                      />
                      AC
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Working"],
                        ["Low Cooling", "Not Working", "NA"],
                        condition?.checkfunctionality?.ac
                      )}`}
                    >
                      {firstLetterUpperCase(condition?.checkfunctionality?.ac)}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <img
                        src={carAudio}
                        width={22}
                        height={22}
                        loading="eager"
                        alt="FuelImage"
                      />
                      Radio / Infotainment System
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["Available"],
                        ["Available but Not Working", "Not Available"],
                        condition?.checkfunctionality?.radio
                      )}`}
                    >
                      {firstLetterUpperCase(
                        condition?.checkfunctionality?.radio
                      )}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <LuCar
                        style={{ width: 22, height: 22 }}
                        color="#00000087"
                      />
                      Interior Lights
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["All Working"],
                        ["Few Not Working", "Not Working Completely"],
                        condition?.checkfunctionality?.interior_lights
                      )}`}
                    >
                      {firstLetterUpperCase(
                        condition?.checkfunctionality?.interior_lights
                      )}
                    </div>
                  </div>
                  <div className="carDetails">
                    <div className="condition-para me-2">
                      <img
                        src={seatImage}
                        width={22}
                        height={22}
                        loading="eager"
                        alt="FuelImage"
                      />
                      Seat Belt
                    </div>
                    <div
                      className={`condition-para fw-semibold ${getColor(
                        ["All Working"],
                        ["Few Not Working", "Not Working Completely"],
                        condition?.checkfunctionality?.seatbelt
                      )}`}
                    >
                      {firstLetterUpperCase(
                        condition?.checkfunctionality?.seatbelt
                      )}
                    </div>
                  </div>
                  {condition?.checkfunctionality?.comment && (
                    <div className="carDetails">
                      <div className="condition-para me-2">
                        <LuCar
                          style={{ width: 22, height: 22 }}
                          color="#00000087"
                        />
                        Comment
                      </div>
                      <div className="condition-para fw-semibold">
                        {firstLetterUpperCase(
                          condition?.checkfunctionality?.comment
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="row form-row m-0">
                <div className="col col-12 comments">
                  <p className="sub-heading">Other comments</p>
                  <form>
                    <textarea
                      name="comments"
                      value={firstLetterUpperCase(condition?.comments)}
                      readOnly
                      id=""
                      cols="10"
                      rows="5"
                    ></textarea>
                    <input
                      type="checkbox"
                      checked={condition?.verify_status === 1 ? true : false}
                      readOnly
                      name="verified"
                      id="verified"
                    />
                    <label className="condition-para" htmlFor="verified">
                      Client verified and confirmed digitally
                    </label>
                  </form>
                  <div className="car-conditon-footer">
                    <div className="condition-para showIcons">
                      {/* <span>
                        <IoMdCheckmarkCircleOutline className="red" />
                        Tested Ok
                      </span>
                      <span>
                        <IoMdCheckmarkCircleOutline className="orange" />
                        Imperfection
                      </span>
                      <span>
                        <FaRegFileExcel className="red" />
                        Not available
                      </span> */}
                    </div>
                    <div
                      style={{ textDecoration: "underline", color: "#D7000C" }}
                    >
                      {/* <Link className="sub-heading red" to="#">
                        View Gallery for car images
                      </Link> */}
                      <button
                        type="button"
                        className="btn btn-link sub-heading red"
                        onClick={handleClickOpen}
                      >
                        View Gallery for car images
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Dialog
        open={open}
        onClose={handleClickClose}
        maxWidth="md"
        fullWidth={true}
      >
        <DialogTitle>Gallery</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClickClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CgClose />
        </IconButton>
        {isLoading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "500px" }}
          >
            <Loading />
          </div>
        ) : fileData.length > 0 ? (
          <DialogContent style={{ height: "500px" }} className="mb-3">
            <ImageList cols={4} rowHeight={164}>
              {fileData.map((item) => (
                <ImageListItem key={item.id}>
                  <>
                    {/* <Link
                      to={replaceUrl(item.url)}
                      target="_blank"
                      style={{ with: "100% !important", height: "150px" }}
                    > */}
                    {!isVideoUrl(item.url) ? (
                      <img
                        srcSet={`${replaceUrl(item.url)}?w=164&h=164`}
                        src={`${replaceUrl(item.url)}?w=164&h=164`}
                        alt={item.tag}
                        loading="lazy"
                        style={{
                          with: "100% !important",
                          height: "150px",
                          cursor: "pointer",
                        }}
                        onClick={() => window.open(replaceUrl(item.url))}
                      />
                    ) : (
                      <video
                        autoPlay
                        muted
                        playsInline
                        loop
                        width="100%"
                        onClick={() => window.open(replaceUrl(item.url))}
                        style={{ cursor: "pointer" }}
                      >
                        <source
                          src={replaceUrl(item.url)}
                          type={`video/${item.url
                            .split(".")
                            .pop()
                            .toLowerCase()}`}
                        />
                      </video>
                    )}
                    {/* </Link> */}
                    <ImageListItemBar
                      title={firstLetterUpperCase(item.tag)}
                      subtitle={item.author}
                    />
                  </>
                </ImageListItem>
              ))}
            </ImageList>
          </DialogContent>
        ) : (
          <DialogContent
            className="d-flex justify-content-center align-items-center"
            style={{ height: "300px" }}
          >
            <p>No media available</p>
          </DialogContent>
        )}
      </Dialog>
    </div>
  );
};

export default CarCondition;
